/**
 * 需求文档 https://makeblock.feishu.cn/wiki/HM8fwdacyiPiBjkELoNc3H5Wngf
 * 实现控制弹窗展示
 * 1.在icon-css.liquid通过css设置自动弹窗父元素隐藏
 * 2.维护dialogList弹窗列表，用于控制弹窗展示顺序
 * 3.监听body下元素新增、删除，处理自动弹窗、手动弹窗相关逻辑
 {  父层元素数据
    parentData: {
      // 父元素选择器，用于实现自动弹窗通过css设置弹窗隐藏，可以是弹窗元素本身，必填
      // 当父元素为body时，弹窗元素type必须为1，即弹窗元素基于body新增/删除控制弹窗展示/隐藏
      selector: 'pt-experience',
      // 父元素类型，web_component: 网页组件，不填写时，表示父元素为普通元素，选填
      type: 'web_component',
      // 控制弹窗展示的类型，1: 通过属性控制，2: 通过css控制，默认2，选填
      controlType: 1,
      // 控制弹窗展示的属性，对应icon-css.liquid中的css属性，自动弹窗必填
      key: 'display',
      // 控制弹窗展示的值，当controlType为1时，showValue为属性值，当controlType为2时，showValue为css值，选填
      showValue: 'block',
    },
    dialogData: {
      // 弹窗元素选择器，必填
      selector: '#engage_popup_aef5245a-78cd-4eae-8b8a-556f44574120',
      // 弹窗展示类型，1: 弹窗元素存在-显示，弹窗元素删除-隐藏，2: 通过css key控制弹窗显示/隐藏，属性值为showValue-显示，属性值为closeValue-隐藏，3: 通过属性控制弹窗显示/隐藏，key 属性存在-显示，属性不存在-隐藏，4: 通过class控制弹窗显示/隐藏，key class存在-显示，class不存在-隐藏，必填
      type: 1,
      // 控制弹窗展示key，type不等于1时，可以是css属性或者class 必填
      key: 'display',
      // 控制弹窗展示的值，type等于2时，必填
      showValue: 'block',
      // 控制弹窗展示的值，type等于2时，必填
      closeValue: 'none',
    },
    // 弹窗展示类型，auto: 自动弹出，manual: 手动弹出，all: 自动/手动弹出 必填
    showType: 'auto',
    // 弹窗展示延迟时间，关闭弹窗后，等待delay时间后，自动弹出下一个弹窗，选填
    delay: 5000,
    // 弹窗类型，kv: klaviyo，pt: pt，kv弹窗时必填
    dialogType: 'kv'
  },
 */

(function () {
  const MAX_RETRY_COUNT = 50;
  const PT_STR = 'pt-experience';
  // 监听map，key: 父层元素选择器，value: 监听器，防止重复监听
  const observeMap = new Map();
  // 模态弹窗弹出时，需要隐藏的非模态弹窗列表
  const hiddenList = [{
    // ip
    selector: 'plugin-redirect-bar',
    defaultDisplayValue: '',
  }, {
    // 小象聊天
    selector: '#kuaida-chatbot-bubble-window',
    defaultDisplayValue: '',
  }, {
    // pushowl
    selector: 'dialog.pushowl-optin',
    defaultDisplayValue: '',
  }, {
    // divi
    selector: '.mk-popover-placement-topRight',
    defaultDisplayValue: '',
  }, {
    // 翻译弹窗
    selector: '#transcySwitcherContainer',
    defaultDisplayValue: '',
  }];
  // 重试次数
  let retryCount = 0;
  // 等待展示的自动弹窗列表
  let pendingAutoShowDialogList = [];
  // 手动弹窗列表
  let manualDialogList= [];
  // 手动弹窗列表，父层元素为body
  let bodyManualDialogList = [];
  // 当前展示的弹窗
  let currentDialog = null;
  let bodyOverflowStyle = '';

  /**
   * 判断弹窗是否是pt弹窗
   * @param {*} data 弹窗元素数据
   * @returns boolean true: 是pt弹窗，false: 不是pt弹窗
   */
  function isPtDialog(data) {
    const { parentData } = data;
    return parentData.selector === PT_STR;
  }
  async function sleep(time) {
    return new Promise((resolve) => setTimeout(() => resolve(1), time));
  }
  // 处理小象聊天
  function handleKuaidaDialog(hidden = true) {
    hiddenList.forEach(item => {
      const el = document.querySelector(item.selector);
      if (el) {
        if (!item.defaultDisplayValue) {
          item.defaultDisplayValue = getComputedStyle(el).display;
        }
        el.style.display = hidden ? 'none' : item.defaultDisplayValue;
      }
    });
  }
  async function handleBodyOverflowStyle(hidden = true) {
    await sleep(20);
    document.body.style.overflow = hidden ? 'hidden' : bodyOverflowStyle;
  }
  /**
   * 处理pt弹窗
   * 由于pt弹窗通过web component实现，所有的弹窗元素都在pt-experience组件中
   * pt-experience组件没有提供通过外部css控制内部样式方法(除非通过js控制)，所以通过设置pt-experience组件display:none来隐藏弹窗
   * pt内部实现了一次只会弹一个pt弹窗，因此不需要对pt弹窗进行弹出顺序控制
   * 由于pt-experience组件存在多个弹窗，因为需要监听pt-experience组件内部弹窗的显示和隐藏
   */
  function handlePtDialog() {
    const ptEl = document.querySelector(PT_STR);
    if (ptEl && ptEl.shadowRoot && !observeMap.has(PT_STR)) {
      const observer = new MutationObserver(() => {
        handleAutoDialog(true);
        handleCurrentDialogClose();
      });
      observer.observe(ptEl.shadowRoot, {
        subtree: true,
        childList: true,
      });
      observeMap.set(PT_STR, observer);
    }
  }
  // 监听当前弹窗是否关闭
  function observeCurrentDialog(data) {
    // 如果当前弹窗已经监听，则不重复监听
    if (!observeMap.has(data.parentData.selector)) {
      const { parentEl } = getParentElement(data);
      if (parentEl) {
        const observer = new MutationObserver(() => {
          handleCurrentDialogClose();
        });
        observer.observe(parentEl, {
          subtree: true,
          childList: true,
          attributes: true
        });
        observeMap.set(data.parentData.selector, observer);
      }
    }
  }

  /**
   * 获取弹窗父层元素
   * 当父层元素是web component组件时，需要获取组件的shadowRoot作为父层元素
   * 另外设置弹窗展示，需要设置弹窗元素的属性/css，所以需要返回当前元素
   * @param {*} data 弹窗元素父层数据
   * @returns 
   * { parentEl: 父层元素, currentEl: 当前元素 }
   */
  function getParentElement(data) {
    const { type, selector } = data;
    const currentEl = document.querySelector(selector);
    let parentEl = currentEl;
    if (type === 'web_component') {
      parentEl = currentEl?.shadowRoot;
    }
    return { parentEl, currentEl };
  }

  function handleManualDialog() {
    for (const item of manualDialogList) {
      // 如果当前弹窗已经监听，则不重复监听
      if (observeMap.has(item.parentData.selector)) {
        continue;
      }
      const { parentEl, currentEl } = getParentElement(item.parentData);
      if (parentEl) {
        const observer = new MutationObserver(async () => {
          // 弹窗嵌套弹窗时，用户点击弹窗元素触发弹窗时，嵌套弹窗元素不处理
          const isShow = !currentDialog && dialogIsShow(item);
          if (isShow) {
            // 弹窗类型为all时，需要去掉默认隐藏弹窗样式
            if (item.showType === 'all') {
              // 由于该类型弹窗存在动效，所以需要先隐藏弹窗，再展示弹窗，此时会操作弹窗元素属性
              // 导致触发监听回调，触发handleCurrentDialogClose，导致元素属性被重置，所以需要先断开监听，弹窗展示后，再重新监听
              observer.disconnect();
              await showAutoDialog(item, currentEl, parentEl, true);
              observer.observe(parentEl, {
                subtree: true,
                childList: true,
                attributes: true,
              });
            } else {
              handleKuaidaDialog(true);
              currentDialog = item;
            }
          }
          handleCurrentDialogClose();
        });
        observer.observe(parentEl, {
          subtree: true,
          childList: true,
          attributes: true,
        });
        observeMap.set(item.parentData.selector, observer);
      }
    }
  }

  /**
   * 获取弹窗元素
   * @param {*} data 弹窗元素数据
   * @returns 弹窗元素
   */
  function getDialogElement(data) {
    const { parentData, dialogData } = data;
    const { parentEl } = getParentElement(parentData);
    return parentData.selector === dialogData.selector ? parentEl : parentEl?.querySelector(dialogData.selector);
  }
  /**
   * 基于弹窗父层元素使用MutationObserver监听当前弹窗是否关闭
   * 当弹窗关闭时，需要处理自动弹窗模态弹窗相关逻辑
   * @returns 
   */
  async function handleCurrentDialogClose() {
    if (!currentDialog) {
      return;
    }
    const { dialogData } = currentDialog;
    const { type } = dialogData;
    const dialogElement = getDialogElement(currentDialog);
    // 如果弹窗类型不是1并且没有找到弹窗元素，则不处理
    if (type !== 1 && !dialogElement) {
      return;
    }
    const isClose = !dialogIsShow(currentDialog);
    if (isClose) {
      // 由于pt内部存在多个弹窗，当关闭pt弹窗时，需要将pt-experience组件的display设置为none
      if (isPtDialog(currentDialog)) {
        const ptEl = document.querySelector(PT_STR);
        if (ptEl) {
          ptEl.style.display = 'none';
        }
      }
      currentDialog = null;
      handleBodyOverflowStyle(false);
      handleKuaidaDialog(false);
      // 处理自动弹窗
      handleAutoDialog(false);
    } else {
      // 触发时，currentDialog存在，可能是关闭弹窗的弹窗，此时需要禁用body的滚动
      handleBodyOverflowStyle(true);
    }
  }

  /**
   * 判断弹窗是否展示
   * 弹窗元素不存在时，返回false
   * type 等于1时，弹窗元素存在，返回true
   * type 等于2时，判断弹窗元素css属性值是否等于showValue
   * type 等于3时，判断弹窗元素是否存在对应属性
   * type 等于4时，判断弹窗元素是否存在对应class
   * @param {*} data 弹窗元素数据
   * @returns boolean false: 弹窗元素隐藏，true: 弹窗元素展示
   */
  function dialogIsShow(data) {
    const { type, key, showValue } = data.dialogData;
    const dialogElement = getDialogElement(data);
    if (!dialogElement) {
      return false;
    }

    switch (type) {
      case 1:
        if (data.dialogType === 'kv') {
          // kv弹窗需要特殊处理，kv弹窗可以是通过css隐藏，也可能是删除/添加元素
          const el = dialogElement.closest('[role="dialog"][aria-label="POPUP Form"]');
          const style = getComputedStyle(el);
          return style.display !== 'none';
        }
        return true;
      case 2: {
        const style = getComputedStyle(dialogElement);
        const keyValue = style[key];
        return keyValue === showValue;
      }
      case 3:
        return dialogElement.hasAttribute(key);
      case 4: {
        const classList = dialogElement.classList;
        return classList.contains(key);
      }
      default:
        return false;
    }
  }

  /**
   * 处理自动弹窗
   * 1.自动弹窗由各个弹窗代码自动弹出，因此只需要在弹窗元素展示时，去掉通过css设置的默认隐藏样式即可
   * 2.只有当前环境下不存在展示弹窗时，才需要处理自动弹窗
   * 3.遍历自动弹窗列表，如果弹窗元素存在，则展示弹窗，否则将其插入到队列末尾，等待下一次处理
   * @param {*} immediate 
   * @returns 
   */
  function handleAutoDialog(immediate = true) {
    if (currentDialog) return;
    // 取出第一个弹窗
    const data = pendingAutoShowDialogList.shift();
    if (data) {
      const { currentEl, parentEl } = getParentElement(data.parentData);
      const isShow = dialogIsShow(data);
      if (isShow) {
        showAutoDialog(data, currentEl, parentEl, immediate);
      } else {
        // 弹窗元素此时未展示，将其插入到队列末尾
        pendingAutoShowDialogList.push(data);
        // 超出最大重试次数后，不再递归
        if (retryCount <= MAX_RETRY_COUNT) {
          retryCount++;
          handleAutoDialog(immediate);
        }
      }
    }
  }
  function toggleDialog(el, dialogData, show = true) {
    if (el) {
      const { type, key, showValue = '', closeValue = '' } = dialogData;
      switch (type) {
        case 2:
          el.style[key] = show ? showValue : closeValue;
          break;
        case 3:
          if (show) {
            el.setAttribute(key, showValue);
          } else {
            el.removeAttribute(key);
          }
          break;
        case 4:
          el.classList.toggle(key, show);
          break;
        default:
          break;
      }
    } 
  }

  async function commonShowDialog(data, currentEl, parentEl) {
    const { parentData, dialogData, showType } = data;
    const { controlType, key, showValue = '' } = parentData;
    if (!currentDialog) {
      // 由于pt是通过js生成，当pt元素产生时，会执行清除内连样式，导致pt元素的display属性被重置为none
      // 延迟处理，避免pt元素的display属性被重置为none
      // 后续还有问题，调整handleAutoDialog实现，遍历所有自动弹窗，查找自动弹窗是否显示，显示展示，否则不做处理
      await sleep(50);
      // 弹窗类型为all时，由于存在动效，所以需要先隐藏弹窗，再展示弹窗
      let allDialogEl = null;
      if (showType === 'all') {
        allDialogEl = parentEl.querySelector(dialogData.selector);
        toggleDialog(allDialogEl, dialogData, false);
      }
      // 设置弹窗父层元素展示
      if (controlType === 1) {
        currentEl.setAttribute(key, showValue || '');
      } else {
        currentEl.style[key] = showValue;
      }
      currentDialog = data;
      handleBodyOverflowStyle(true);
      handleKuaidaDialog(true);
      if (allDialogEl) {
        await sleep(30);
        toggleDialog(allDialogEl, dialogData, true);
      }

      // 从自动弹窗列表中移除当前弹窗
      pendingAutoShowDialogList = pendingAutoShowDialogList.filter(item => item.dialogData.selector !== dialogData.selector);
      
      observeCurrentDialog(data);
    } else {
      // 当前已经展示弹窗，插入到第一个，等待关闭后展示
      pendingAutoShowDialogList.unshift(data);
    }
  }

  async function showAutoDialog(data, currentEl, parentEl, immediate = false) {
    const { delay = 0 } = data;
    if (immediate) {
      await commonShowDialog(data, currentEl, parentEl);
    } else {
      setTimeout(() => {
        commonShowDialog(data, currentEl, parentEl);
      }, delay);
    }
  }

  /**
   * 处理父元素是body的手动弹窗
   * 该类型弹窗是通过在body中删除/添加对应弹窗元素实现弹窗展示/隐藏
   */
  function handleManualDialogBaseBody() {
    bodyManualDialogList.find(item => {
      const isShow = !currentDialog && dialogIsShow(item);
      if (isShow) {
        // 用户点击弹窗，设置当前弹窗
        currentDialog = item;
        handleKuaidaDialog(true);
        return true;
      }
    });
    // 监听当前弹窗关闭
    handleCurrentDialogClose();
  }

  document.addEventListener('DOMContentLoaded', () => {
    const dialogList = [...window.autoDialogList, ...window.commonDialogList];
    // 获取自动、手动弹窗
    const { manual, auto } = dialogList.reduce((acc, item) => {
      if (['manual', 'all'].includes(item.showType)) {
        if (item.parentData.selector === 'body') {
          acc.manual.set('body', [...(acc.manual.get('body') || []), item]);
        } else {
          acc.manual.set('other', [...(acc.manual.get('other') || []), item]);
        }
      }
      if (['auto', 'all'].includes(item.showType)) {
        acc.auto.push(item);
      }
      return acc;
    }, { manual: new Map(), auto: [] });

    // 基于body手动弹窗列表
    bodyManualDialogList = [...manual.get('body').values()];
    // 父元素不是body的手动弹窗列表
    manualDialogList = [...manual.get('other').values()];
    // 自动弹窗列表
    pendingAutoShowDialogList = auto;
    
    // 对于自动弹窗进行节流处理
    const throttle = __Xtool_Utils.throttle(() => {
      retryCount = 0;
      handlePtDialog();
      handleAutoDialog();
    }, 300);
    const observer = new MutationObserver(() => {
      throttle();
      handleManualDialog();
      handleManualDialogBaseBody();
    });
    observer.observe(document.body, {
      subtree: true,
      childList: true,
    });
    bodyOverflowStyle = document.body.style.overflow;
  });
})();
  